export const environment = {
    production: true,
    backendBaseUrlApis: 'https://api.wedshed.com.au',
    websiteUrl: 'https://www.wedshed.com.au',
    businessPortalUrl: 'https://portal.wedshed.com.au',
    imageKitUrl: 'https://ik.imagekit.io/wedshed/production/',
    googleRecaptchaKey: '6LcBtQIrAAAAAKroGMAJuKmmC1riJ-AxMuvCBqrO',
};
